<template>
  <el-dialog
    :visible.sync="visible"
    :append-to-body="true"
    width="680px"
    custom-class="std-vip-dialog"
    :show-close="false"
    @open="createQrOrder"
    @close="$emit('close')"
  >
    <div class="vip-dialog-body">
      <!-- 关闭按钮 -->
      <button class="close-btn" @click="$emit('close')">×</button>

      <!-- 头部 -->
      <div class="vip-header">
        <div class="vip-badge">SVIP</div>
        <div class="vip-title">升级成为超级会员</div>
      </div>

      <!-- 提示 -->
      <div class="vip-notice">
        <span class="notice-tag">友情提示</span>
        该零部件所属企业目前非平台正式会员，若继续使用，您需要升级成为平台<span class="text-red">超级会员</span>。
      </div>
      <div class="vip-price-line">
        超级会员正常有效期为一年，年费199元。当前为优惠活动期间，<span class="text-red">有效期延长为 199元五年</span>。
      </div>

      <!-- 主体：权限列表 + 二维码 -->
      <div class="vip-main">
        <div class="vip-permissions">
          <div class="perm-title">超级会员的权限</div>
          <div class="perm-item">
            <span class="perm-num">1</span>
            <div>五年总费用 <span class="text-red">199元</span>，平均每年仅 <span class="text-red">39.8元</span></div>
          </div>
          <div class="perm-item">
            <span class="perm-num">2</span>
            <div>大工程师平台<span class="text-orange">所有模型可以任意下载</span>，不再有任何限制<span class="text-muted">（提醒：部分产品请自行校对数字模型的准确性）</span></div>
          </div>
          <div class="perm-item">
            <span class="perm-num">3</span>
            <div>标准材智库可以任意查询使用，不再另行收费</div>
          </div>
          <div class="perm-item">
            <span class="perm-num">4</span>
            <div>所在企业如需上传产品图片或者产品模型，免费提供技术支持，上传免费</div>
          </div>
          <div class="perm-item">
            <span class="perm-num">5</span>
            <div>所在企业如果是机电零部件供应商企业，可以享受优惠使用<span class="text-red">销售专用获客工具</span>，具体可直接咨询客服。</div>
          </div>
        </div>
        <div class="vip-qrcode" v-loading="qrLoading">
          <div class="qrcode-tag">🔥 优惠期间，有效期5年</div>
          <div class="qrcode-box">
            <canvas id="stdVipQrcode" width="150" height="150"></canvas>
          </div>
          <div class="qrcode-label">微信扫码，成为超级会员</div>
          <div class="qrcode-contact">若有疑问，请加微信</div>
          <div class="qrcode-wechat">19564151511</div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <span class="btn-default" @click="$emit('close')">我知道了</span>
      <span class="btn-primary" @click="goContact">联系客服</span>
    </span>
  </el-dialog>
</template>

<script>
import { ChatService, TodaySearchService } from '@/service';
import { Category } from '@/libs';
import UQRCode from 'uqrcodejs';

export default {
  props: {
    visible: { type: Boolean, default: false },
    orderType: { type: Number, default: 2 }, // 1=下载模型场景 2=搜标准场景
  },
  data() {
    return {
      qrLoading: false, // 二维码加载中
      qrReady: false, // 二维码已生成
    };
  },
  methods: {
    // ----------- 创建支付订单并画二维码（dialog open 事件触发，确保 canvas 已渲染）
    async createQrOrder() {
      this.qrReady = false;
      this.qrLoading = true;
      const res = await TodaySearchService.createMemberOrder(this.orderType);
      this.qrLoading = false;
      const payUrl = res?.data?.payUrl || res?.data?.order?.payUrl;
      if (res.code !== 0 || !payUrl) return;
      const canvas = document.getElementById('stdVipQrcode');
      if (!canvas) return;
      const qr = new UQRCode();
      qr.data = payUrl; // 微信支付链接
      qr.size = 150;
      qr.setOptions({ margin: 2 });
      qr.make();
      qr.canvasContext = canvas.getContext('2d');
      qr.drawCanvas();
      this.qrReady = true;
    },
    // ----------- 联系客服
    goContact() {
      this.$emit('close');
      ChatService.StartRecent(Category.User, 221992398939168);
    },
  },
};
</script>

<style lang="less">
.std-vip-dialog {
  margin-top: 8vh !important;
  border-radius: 9px;
  overflow: hidden;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.12);

  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    padding: 16px 32px 24px;
    border-top: 1px solid #f2f3f5;
  }
}

@keyframes badge-shine {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.vip-dialog-body {
  padding: 32px 32px 24px;
  position: relative;
}

// 关闭按钮
.close-btn {
  position: absolute;
  top: 16px;
  right: 20px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f5f6f8;
  border: none;
  color: #999;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 5;

  &:hover {
    background: #e8e9eb;
    color: #333;
  }
}

// 头部
.vip-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f2f5;

  .vip-badge {
    background: linear-gradient(135deg, #b8860b, #daa520, #ffd700, #daa520, #fb0202);
    background-size: 200% 200%;
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    padding: 4px 14px;
    border-radius: 20px;
    letter-spacing: 2px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    box-shadow: 0 2px 8px rgba(218, 165, 32, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3);
    animation: badge-shine 3s ease-in-out infinite;
  }
  .vip-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;
  }
}

// 提示区
.vip-notice {
  font-size: 14px;
  line-height: 1.9;
  color: #333;
  margin-bottom: 10px;

  .notice-tag {
    display: inline-block;
    background: #fff7e6;
    color: #e6a23c;
    font-size: 12px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
    margin-right: 4px;
    vertical-align: middle;
  }
  .text-red {
    color: #f56c6c;
    font-weight: 600;
  }
  .text-orange {
    color: #e6a23c;
    font-weight: 600;
  }
}

.vip-price-line {
  font-size: 14px;
  line-height: 1.9;
  color: #666;
  margin-bottom: 24px;

  .price-big {
    color: #f56c6c;
    font-weight: 700;
    font-size: 18px;
  }
  .text-red {
    color: #f56c6c;
    font-weight: 600;
  }
  .text-orange {
    color: #e6a23c;
    font-weight: 600;
  }
}

// 主体
.vip-main {
  display: flex;
  gap: 28px;
  align-items: flex-start;
}

// 权限列表
.vip-permissions {
  flex: 1;

  .perm-title {
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 14px;
  }
  .perm-item {
    display: flex;
    align-items: flex-start;
    font-size: 13px;
    line-height: 2;
    color: #444;
    margin-bottom: 8px;

    .perm-num {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      background: linear-gradient(145deg, #ecf3ff, #d9e9ff);
      color: #1d4ed8;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      font-weight: 700;
      margin-right: 10px;
      margin-top: 3px;
      box-shadow: 0 2px 6px rgba(37, 99, 235, 0.08), 0 0 0 1px rgba(59, 130, 246, 0.1);
    }
    .text-red {
      color: #f56c6c;
      font-weight: 600;
    }
    .text-orange {
      color: #e6a23c;
      font-weight: 600;
    }
    .text-muted {
      color: #838282;
      font-size: 12px;
    }
  }
}

// 二维码区域
.vip-qrcode {
  flex-shrink: 0;
  width: 190px;
  text-align: center;
  background: rgba(248, 251, 255, 0.8);
  padding: 16px 14px 14px;
  border-radius: 20px;
  border: 1px solid rgba(59, 130, 246, 0.08);

  .qrcode-tag {
    display: inline-block;
    background: linear-gradient(135deg, #ff9f43, #f56c6c);
    color: #fff;
    font-size: 12px;
    padding: 3px 12px;
    border-radius: 20px;
    margin-bottom: 12px;
    box-shadow: 0 4px 12px rgba(245, 108, 108, 0.2);
  }
  .qrcode-box {
    background: #fff;
    padding: 8px;
    border-radius: 16px;
    box-shadow: 0 4px 10px -4px rgba(0, 27, 65, 0.08), 0 0 0 1px rgba(37, 99, 235, 0.08);
    margin-bottom: 10px;
    display: inline-block;
  }
  .qrcode-label {
    font-size: 13px;
    color: #333;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .qrcode-contact {
    font-size: 12px;
    color: #999;
    margin: 4px 0;
  }
  .qrcode-wechat {
    font-size: 16px;
    font-weight: 700;
    color: #1d4ed8;
    letter-spacing: 1px;
  }
}

// 底部按钮
.dialog-footer {
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 16px;

  .btn-default {
    padding: 10px 36px;
    border-radius: 50px;
    border: 1.5px solid #dcdfe6;
    background: #fff;
    color: #333;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: #1890ff;
      color: #1890ff;
    }
  }
  .btn-primary {
    padding: 10px 36px;
    border-radius: 50px;
    border: none;
    background: linear-gradient(145deg, #1e4bd2, #2563eb);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s;
    box-shadow: 0 6px 16px -4px rgba(30, 75, 210, 0.4);

    &:hover {
      background: linear-gradient(145deg, #2563eb, #3b82f6);
      box-shadow: 0 10px 20px -6px rgba(30, 75, 210, 0.5);
      transform: translateY(-1px);
    }
  }
}
</style>
